// src/contexts/AuthContext.js - VERSIÓN SIMPLIFICADA SIN PERSISTENCIA
import React, { createContext, useContext, useState } from 'react'
import { supabase, getCurrentUserProfile } from '../lib/supabase'

const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(false)

  // Función para login
  const login = async (userData) => {
    setLoading(true)
    try {
      setUser(userData.user)
      
      // Cargar perfil
      const { data: profileData, error } = await getCurrentUserProfile()
      if (error) {
        console.error('Error cargando perfil:', error)
        throw error
      }
      
      setProfile(profileData)
      return { success: true }
    } catch (error) {
      console.error('Error en login:', error)
      setUser(null)
      setProfile(null)
      return { success: false, error }
    } finally {
      setLoading(false)
    }
  }

  // Función para logout
  const logout = async () => {
    try {
      await supabase.auth.signOut()
      setUser(null)
      setProfile(null)
      
      // Limpiar cualquier dato local
      localStorage.clear()
      sessionStorage.clear()
      
      return { success: true }
    } catch (error) {
      console.error('Error en logout:', error)
      return { success: false, error }
    }
  }

  // Función para refrescar perfil
  const refreshProfile = async () => {
    if (!user) return

    try {
      const { data: profileData, error } = await getCurrentUserProfile()
      if (error) {
        console.error('Error refrescando perfil:', error)
        return
      }
      
      if (profileData) {
        setProfile(profileData)
      }
    } catch (error) {
      console.error('Error refrescando perfil:', error)
    }
  }

  const value = {
    user,
    profile,
    loading,
    login,
    logout,
    refreshProfile,
    isAuthenticated: !!user && !!profile
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext